export default "__VITE_ASSET__xr23rsFz__"